import { connect } from 'react-redux';
import NotFoundView from './NotFoundView';

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundView);



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFoundContainer.js